module.exports = [
    'strongly agree',
    'agree',
    'disagree',
    'strongly disagree',
]